import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useRouter } from "./../util/router.js";

function Meta(props) {
  const { children, ...customPageMeta } = props;
  const router = useRouter();

  useEffect(() => {
    const loadGTM = (id) => {
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
      script.async = true;
      document.head.appendChild(script);

      script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag(){window.dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', id);
      };
    };

    // Load both GTM scripts
    loadGTM('AW-16592466765');
    loadGTM('G-WEH3E6BZ1J');
  }, []);

  // Meta values that are the same across all pages
  const globalMeta = {
    // Site name
    siteName: "ChurchLink",
    // Your production domain (example: https://myapp.com)
    domain: "https://churchlink.page",
    // Your Twitter handle (example: @divjoy)
    twitterHandle: "churchlink_page",
  };

  // Default meta values for current page (override with props)
  const defaultPageMeta = {
    // Page title
    title: "ChurchLink",
    // Page description
    description: "A simple way to stay connected to your people.",
    // Social share image (create this file in /public/images/)
    image: require('./../images/share.jpg'),
    // Page type (see https://ogp.me/#types)
    type: "website",
  };

  // Construct meta object from global, default, and custom meta
  const meta = { ...globalMeta, ...defaultPageMeta, ...customPageMeta };

  // Note: Each tag should have a unique `key` so that they are de-deduped if other
  // `Meta` components are rendered on the same page or within nested components.
  // prettier-ignore
  return (
    <Helmet>
      <title>{meta.title}</title>
      <link rel="icon" href={require('./../images/favicon.ico')} />
      <link rel="shortcut icon" href={require('./../images/favicon.ico')} />
      <link rel="apple-touch-icon" href={require('./../images/favicon.ico')} />
      <link rel="apple-touch-icon" sizes="128x128" href={require('./../images/home-icon.jpg')} />
      
      <meta name="apple-mobile-web-app-title" content={meta.title} />

      <meta content={meta.description} name="description" key="description" />
      {meta.domain && <link rel="canonical" href={`${meta.domain}${router.pathname}${router.location.search}`} key="canonical" />}

      {/* Open Graph */}
      <meta property="og:title" content={meta.title} key="og-title" />
      <meta property="og:description" content={meta.description} key="og-description" />
      <meta property="og:site_name" content={meta.siteName} key="og-site-name" />
      <meta property="og:type" content="website" key="og-type" />
      {meta.domain && <meta property="og:url" content={`${meta.domain}${router.pathname}${router.location.search}`} key="og-url" />}
      {meta.domain && meta.image && <meta property="og:image" content={`${meta.domain}${meta.image}`} key="og-image" />}

      {/* Twitter */}
      <meta name="twitter:title" content={meta.title} key="twitter-title" />
      <meta name="twitter:description" content={meta.description} key="twitter-description"/>
      <meta name="twitter:card" content="summary_large_image" key="twitter-card" />
      {meta.twitterHandle && <meta name="twitter:site" content={meta.twitterHandle} key="twitter-site" />}
      {meta.domain && meta.image && <meta name="twitter:image" content={`${meta.domain}${meta.image}`} key="twitter-image" />}

      {/* Google tag (gtag.js) */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=AW-16592466765"></script>
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-WEH3E6BZ1J"></script>
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('config', 'AW-16592466765');
          gtag('config', 'G-WEH3E6BZ1J');
        `}
      </script>
    </Helmet>
  );
}

export default Meta;
